<script setup lang="ts">
import { useLeftSidebarStore } from '~~/src/stores/leftSidebar'
import IconButton from '~~/src/components/IconButton/index.vue'

defineEmits(['toggleOpen', 'backPage'])

defineOptions({
  name: 'DrawerHeader',
})

const state = useLeftSidebarStore()
</script>

<template>
  <div class="px-1">
    <IconButton
      class="w-9 h-9 basis-1"
      title="Toggle Menu"
      @click="state.toggleSidebar()"
    >
      <IconDockLeft v-if="state.isOpen" class="w-6 h-6" />
      <IconDockRight v-else class="w-6 h-6" />
    </IconButton>
  </div>
</template>
